import React, { useEffect, useState } from 'react'
import APIOnboard from 'util/onboardApi'
import API from 'util/Api'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography, Slide, Box,TextField, Grid, FormControl, InputLabel } from '@material-ui/core';
import ContainerHeader from 'components/ContainerHeader'
import SnackBar from 'components/SnackBar'
import { Formik } from 'formik'
import UserDetails from './UserDetails'
import ActionsTable from "components/ActionsTable/TableList";
import * as Yup from "yup";
import _ from "lodash";
import { LinearProgress as LinearProgres } from "@material-ui/core";
import Refresh from '@material-ui/icons/Refresh';
import CardBox from 'components/CardBox'
import ToolTipIcon from "components/ToolTipIcon";
import { Document, Page, pdfjs } from "react-pdf";
import Zoom from "react-medium-image-zoom";
import 'react-medium-image-zoom/dist/styles.css';
import Slider from "react-slick";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { DialogForm } from 'components/PopUpDialog'
import Autocomplete from '@material-ui/lab/Autocomplete';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const validations = Yup.object().shape({
    city: Yup.object().required('Required'),
})

const fieldValidation = Yup.object().shape({
  // emp_code: Yup.string().required("Required"),
  deployed_vl_id: Yup.object().test("not-empty","Required",(value) => value && Object.keys(value).length > 0).required("Required"),
  vl_shift_start_time: Yup.string().required("Required"),
  vl_shift_end_time: Yup.string().required("Required"),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// const ImageDialog = (images) => {
// 	return ( images.length > 0 ?
// 		<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "16px", padding: "16px" }} >
// 			{images.map((image, index) => (
// 				<div key={index} style={{ position: "relative", width:'100%', height:'100%'}}>
// 					<img
// 						src={image.document_url}
// 						alt={`Preview ${index + 1}`}
// 						style={{
// 							width: "100%",
// 							height:'200px',
// 							// maxHeight:'200px',
// 							borderRadius: "8px",
// 							border: "1px solid #ccc",
// 						}}
// 					/>
// 				</div>
// 			))}
// 		</div>
// 	:
// 		<div style={{ display: "flex", flexDirection:'row', justifyContent:'center'}}>
// 			<Typography>No Image found!</Typography>
// 		</div>
// 	);
// }

const PdfPreview = (file) => {
    const [pdfBlob, setPdfBlob] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
  // console.log(file.document_type,"file.document_type",file.document_url)
    useEffect(() => {
      if ((file.document_type == "tc" && file.document_url) || (file.document_type == "self" && file.document_url)) {
        setLoading(true);
        fetch(file.document_url)
          .then((res) => {
            if (!res.ok) throw new Error("Failed to fetch PDF");
            return res.blob();
          })
          .then((blob) => {
            console.log(blob,"blobblob",file.document_type)
            setPdfBlob(blob);
            setLoading(false);
          })
          .catch((err) => {
            setError(err.message);
            setLoading(false);
          });
      }
    }, [file]);
  
    // if (file.document_type != "tc" || file.document_type != "self") return null;
  
    if (loading) return <div style={{ textAlign: "center" }}>Loading PDF...</div>;
    if (error) return <div style={{ textAlign: "center", color: "red" }}>Error: {error}</div>;
  
    return (
      <div style={{ textAlign: "center",maxHeight:400,maxWidth: 400 }}>
        {pdfBlob ? (
          <Document file={pdfBlob} onLoadError={(e) => setError(e.message)}>
            <Page pageNumber={1} width={500}/>
          </Document>
        ) : (
          <div>No PDF available</div>
        )}
      </div>
    );
};
  
  const docTypeFieldsMap = {
    aadhaar: [
      { key: "aadhaar_name", label: "Name as on Aadhaar Card" },
      { key: "aadhaar_number", label: "Aadhar Number" },
      { key: "aadhaar_address", label: "Address" , multiline : true},
      { key: "aadhaar_dob", label: "Date of Birth" },
      { key: "gender", label: "Gender" },
    ],
    aadhar_front: [
      { key: "aadhaar_name", label: "Name as on Aadhaar Card" },
      { key: "aadhaar_number", label: "Aadhar Number" },
      { key: "aadhaar_dob", label: "Date of Birth" },
      { key: "gender", label: "Gender" },
    ],
    aadhar_back: [
      { key: "aadhaar_number", label: "Aadhar Number" },
      { key: "aadhaar_address", label: "Address", multiline: true },
    ],
    pan: [
      { key: "pan_name", label: "Name as on Pan Card" },
      { key: "pan_number", label: "PAN Number" },
      { key: "pan_dob", label: "Date of Birth" },
      { key: "pan_parent_name", label: "Parent's Name" },
    ],
    dl: [
      { key: "dl_name", label: "Name as on Driving License" },
      { key: "dl_number", label: "License Number" },
      { key: "dl_dob", label: "Date of Birth" },
      { key: "blood_group", label: "Blood Group" },
      { key: "dl_issue_date", label: "License Issue Date" },
      { key: "dl_expiry_date", label: "License Expiry Date" },
    ],
    dl_front: [
      { key: "dl_name", label: "Name as on Driving License" },
      { key: "dl_number", label: "License Number" },
      { key: "dl_dob", label: "Date of Birth" },
      { key: "blood_group", label: "Blood Group" },
      { key: "dl_issue_date", label: "License Issue Date" },
      { key: "dl_expiry_date", label: "License Expiry Date" },
    ],
    bank: [
      { key: "account_holder_name", label: "Account Holder Name" },
      { key: "account_number", label: "Account Number" },
      { key: "ifsc_code", label: "IFSC Code" },
      { key: "bank_name", label: "Bank Name" },
      { key: "branch_address", label: "Bank Address" },
    ],
    bank_passbook: [
      { key: "account_holder_name", label: "Account Holder Name" },
      { key: "account_number", label: "Account Number" },
      { key: "ifsc_code", label: "IFSC Code" },
      { key: "bank_name", label: "Bank Name" },
      { key: "branch_address", label: "Bank Address" },
    ],
    uan:[
      { key: "uan_no", label: "Universal Account Number" }
    ]
    // tc: [
    //   { key: "name", label: "Name" },
    //   { key: "dob", label: "Date of Birth" },
    //   { key: "address", label: "Address", multiline: true },
    // ],
    // Add more document types as needed
  };
const ImageDialog = ({ images = [], user = null }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [dialog, setDialog] = useState({open:false, fullWidth:true, content:null, header:'', agreeBtnTxt:'', disAgreeBtnTxt:'', disableSubmit:false, type:'', callback:null, confirmVerifyUser: null});
    const [snackBar, setSnackBar] = useState({
      open: false,
      message: "",
      type: "error",
    });
    console.log(images,'imagesimagesimages')
    const currentDocType = images[currentIndex]?.document_type || "";
    const currentFields = docTypeFieldsMap[currentDocType] || [];
    const [currentImage, setCurrentImage] = useState(null);
    const [currentImages, setCurrentImages] = useState(null);
    // Initialize formData based on each image's document type and its required fields
    const [formData, setFormData] = useState(() =>
      images.map((image) => {
        const fields = docTypeFieldsMap[image.document_type] || [];
        const initData = {};
        fields.forEach(({ key }) => {
          initData[key] = "";
        });
        initData.status = null;
        return initData;
      })
    );
    useEffect(() => {
      const image = Object.values(images).find(item => item.document_type === currentDocType);
      setCurrentImage(image || {});
      setCurrentImages(images)
    }, [images, currentDocType]);

    // Your PDF preview component or image Zoom component here
    const renderContent = (file) => {
      if (file.document_type == "tc" || file.document_type == "self") {
        return (
          <div style={{ textAlign: "center" }}>
            {PdfPreview(file)}
          </div>
        );
      }

      return (
        <Zoom>
          <img
            src={file.document_url}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "75vh",
              minHeight: "75vh",
              objectFit: "contain",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
        </Zoom>
      );
    };
    
    const confirmVerifyUser = (currentImage,status)=>{
        setDialog({
            open:true,
            header:  `${status ? "Approve" : "Reject"} Document`,
            content:  `Are you sure you want to ${status ? "approve" : "reject"} the documents?`,
            submitBtnLabel:'Confirm',
            disAgreeBtnTxt:'Cancel',
            userData: currentImage,
            callback: ()=>verifyDoc(currentImage,status) ,
            
        })
    }
    const verifyDoc = (currentImage, status)=>{
      setDialog({
        open:false,
      })
      APIOnboard.put("verification",{ type: 'doc', doc_id: currentImage?.id, user_id: user, status : status,...currentImage})
      .then((res) => {
          handleChange('', status ? 'is_accepted' : 'is_rejected',1);
          setCurrentImages((prevImage) => {
            let image = Object.values(images).find(item => item.document_type === currentDocType);
            if(status)
              image.is_accepted = 1
            else
              image.is_rejected = 1
            return {
              ...prevImage,
              ...image
            };
          });
          
          setSnackBar({
              open: true,
              message: res?.data?.msg,
              type: "success",
          })
      })
      .catch((err) => {
          setSnackBar({
              open: true,
              message: err?.response?.data?.msg,
              type: "error",
          })
      })
    }
    const handleDialogClose = ()=>{
      setDialog({
          open:false,
          content:'',
          header:'',
          agreeBtnTxt:'',
          disAgreeBtnTxt:'',
          type:'',
          location:null,
          callback:null
      });
    }
    const handleChange = (doc, key, value)=>{
      setCurrentImage((prevImage) => ({
        ...prevImage,
        [key]: value,
      }));
    }

    if (!images.length) {
      return (
        <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
          <Typography>No Image found!</Typography>
        </div>
      );
    }
    return (
      <div style={{ padding: "16px", minHeight: '500px' }}>
          <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        <Dialog
              open={dialog.open}
              TransitionComponent={Transition}
              keepMounted
              fullWidth
              maxWidth='md'
              onClose={handleDialogClose}
              aria-labelledby="alert-dialog-slide-title"
            >
              {/* <LinearProgress style={{visibility:props.showProgress ? 'visible' : 'hidden'}} color="primary" /> */}
              <DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
              <DialogContent>
                {dialog.content}
              </DialogContent>
              <DialogActions>
                <Button variant="outlined"  color="secondary" onClick={handleDialogClose}> Close</Button>
                {dialog.submitBtnLabel && 
                  <Button variant="outlined"  color="primary" onClick={() => { dialog.callback(dialog.userData)}} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>
                }						
              </DialogActions>
          </Dialog>

        <Grid container spacing={2}>
          {/* Left Side: Document/Image Slider */}
          <Grid item xs={12} md={6}>
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={1}
              slidesToScroll={1}
              afterChange={setCurrentIndex}
              arrows={true}
            >
              {images.map((image, index) => (
                <div key={index}>
                  {renderContent(image)}
                </div>
              ))}
            </Slider>
          </Grid>

          {/* Right Side: Form & Actions */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" style={{ marginBottom: 16 }}>
              Document Type: {currentDocType.toUpperCase() || "N/A"}
            </Typography>

            <Grid container spacing={2}>
              {currentFields.map(({ key, label, multiline }) => (
                <Grid item xs={12} sm={12} key={key}>
                  <TextField
                    label={label}
                    fullWidth
                    multiline={!!multiline}
                    disabled={!currentImage?.is_accepted && !currentImage?.is_rejected ? false  : true}
                    minRows={multiline ? 2 : 1}
                    value={currentImage?.[key] || ""}
                    onChange={(e) => handleChange(currentImage, key, e.target.value)}
                  />
                </Grid>
              ))}
            </Grid>
            <div style={{ display: "flex", gap: 16, marginTop: 16, justifyContent: 'flex-end' }}>
              {
                !currentImage?.is_accepted && !currentImage?.is_rejected ?
                  <>
                      {
                      currentImage?.document_type !== 'tc' &&
                        <Button
                          variant="contained"
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={() => confirmVerifyUser(currentImage, 0)}
                        >
                          Reject
                        </Button>
                      }
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "green", color: "white" }}
                        onClick={() => confirmVerifyUser(currentImage, 1)}
                      >
                        Approve
                      </Button>
                    </>
                    :
                    <Button
                        variant="contained"
                        disabled={true}
                        style={{ backgroundColor: currentImage?.is_accepted ? "green" : "red", color: "white" }}
                        // onClick={() => confirmVerifyUser(currentImage, 0)}
                      >
                        {currentImage?.is_accepted ? 'Accepted' : 'Rejected'}
                      </Button>
                }
            </div>

            {formData[currentIndex]?.status && (
              <Typography
                style={{
                  marginTop: 16,
                  color: formData[currentIndex].status === "approved" ? "green" : "red",
                  fontWeight: "bold",
                }}
              >
                Status: {formData[currentIndex].status.toUpperCase()}
              </Typography>
            )}
          </Grid>
        </Grid>
      </div>
    );
};

const ListUsers = (props) => {

    const [config,setConfig] = useState(null);
    const [values,setValues] = useState({});
    const [initialValues,setInitialValues] = useState([]);
    const [userList,setUserList] = useState(null);
    const [loading,setLoading] = useState(false);
    const [dialog, setDialog] = useState({open:false, fullWidth:true, content:null, header:'', agreeBtnTxt:'', disAgreeBtnTxt:'', disableSubmit:false, type:'', callback:null, confirmVerifyUser: null});
	const [popupDialog, setPopupDialog] = useState({ open: false, formData:{} });
	const [valetLocations, setValetLocations] = useState([])
    const [user,setUser] = useState(null);
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    useEffect(()=>{
        getUsersList();
        API.get("valetLocations").then((res) => {
          let valetLoc = [];
          res.data.data.table.body.map((loc)=> {
            let tempLoc={id:loc.id.value, name:loc.name.value};
            valetLoc.push(tempLoc);
          })
          setValetLocations(valetLoc)
        }).catch((err) => {
        });
    },[])

  const getUsersList = (city_id = null)=>{
  setLoading(true);
  let params = city_id ? `?city_id=${city_id}` : "";
  APIOnboard.get(`onboardingUsers${params}`)
    .then((res) => {
      if (res.data.data.users){
        setUserList(res.data.data.users);
        setInitialValues(res.data.data.users);
        setUser(null)
        let data = {}
        if (res.data.data.config?.fields) {
          for(let key in res.data.data.config.fields){
            data[key] = res.data.data.config.fields[key].value
          }
        }
        setValues(data);
      } else {
        if (res.data.data.config?.fields) {
          let temp = Object.values(res.data.data.config.fields);
          setConfig(temp);
        }
      }
    })
    .catch((err) => {
      setSnackBar({
        open: true,
        message: err?.response?.data?.msg,
        type: "error",
      });
    })
    .finally(()=>{
      setLoading(false)
    })
}
  const resetCity = () => {
    setUser(null);
    setValues({ city: null });
    getUsersList();
}
    const ShowImages = (item) => {
      setDialog({open:true, fullWidth:true, header:`${item.name.value.toUpperCase()} Documents`, submitBtnLabel:'', type:'showImages', callback:null, content: <ImageDialog images={item.images.value} user={item?.id?.value} />,userData:null, confirmVerifyUser : confirmVerifyUser})
    }
    const downloadUserDocuments = async (user) => {
        // console
        let userName = user?.name?.value;
        let documents = user?.images?.value;
        console.log(documents,'documents')
        const zip = new JSZip();
        const folder = zip.folder(userName.replace(/\s+/g, "_")); 
      
        for (let doc of documents) {
          const fileUrl = doc.document_url;
          const fileName = `${doc.document_type || "document"}.${fileUrl.split('.').pop().split('?')[0]}`;
          try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            folder.file(fileName, blob);
          } catch (err) {
            console.error("Failed to fetch:", fileUrl, err);
          }
        }
      
        zip.generateAsync({ type: "blob" }).then((blob) => {
          saveAs(blob, `${userName.replace(/\s+/g, "_")}_Documents.zip`);
        });
    }; 
const filterCity = (e, { setSubmitting, resetForm }) => {
    const cityId = e?.city?.id || "all";
    getUsersList(cityId);
    setSubmitting(false);
}
    const handleDialogClose = ()=>{
      getUsersList();
        setDialog({
            open:false,
            content:'',
            header:'',
            agreeBtnTxt:'',
            disAgreeBtnTxt:'',
            type:'',
            location:null,
            callback:null
        });
    }
    const verifyUser = (userData,type)=>{
        setDialog({
            open:false,
        })
        APIOnboard.put("verification",{user_id : userData?.id?.value, type: type})
        .then((res) => {
            setSnackBar({
                open: true,
                message: res?.data?.msg,
                type: "success",
            })
            getUsersList();
        })
        .catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })
        })
    }
    const confirmVerifyUser = (userData,type)=>{
        setDialog({
            open:true,
            header: type === 'doc' ? `Approve Document` : 'Approve User',
            content: type === 'doc' ? `Are you sure you want to approve the documents?` : 'Are you sure you want to approve the user?',
            submitBtnLabel:'Confirm',
            disAgreeBtnTxt:'Cancel',
            userData: userData,
            callback: ()=>verifyUser(userData,type) ,
            
        })
    }
    const uploadSelfDoc = (userData) => {
        // Create a hidden file input
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".pdf"; // Adjust allowed file types if needed
      
        // On file selection
        fileInput.onchange = async (event) => {
          const selectedFile = event.target.files[0];
          if (!selectedFile) return;
      
          try {
            // Prepare FormData
            const formData = new FormData();
            formData.append("document", selectedFile);
            formData.append("user_id", userData?.id?.value);
      
            // API request to upload the document
            APIOnboard.post("documentUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{
                setSnackBar({
                    open: true,
                    message: res?.data?.msg,
                    type: "success",
                })
                getUsersList();
            });
          } catch (err) {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })          }
        };
      
        // Trigger the file picker
        fileInput.click();
    };
    const valetEZEmpDetail = (user) =>{
      console.log("valetEZEmpDetail--",user.id.value,user.emp_code.value,user.deployed_vl_id.value,"start date",user?.vl_shift_start_time?.value)
      setPopupDialog({
          open: true,
          formData:{
            user_id:user.id.value,
            emp_code:user.emp_code.value,
            deployed_vl_id:user.deployed_vl_id.value,
            vl_shift_start_time :user?.vl_shift_start_time?.value?user.vl_shift_start_time.value:"12:00:00", 
            vl_shift_end_time :user?.vl_shift_end_time?.value ? user.vl_shift_end_time.value:"22:00:00"
          }
      })
    }
    
	const agreeClicked = (data, form) =>{
		
		console.log("valetEZEmpDetail--agreeClicked",data, form);
    data = {...data,vl_shift_start_time : moment(data?.vl_shift_start_time).format("HH:mm:00"), vl_shift_end_time : moment(data?.vl_shift_end_time).format("HH:mm:00")}
		APIOnboard.post("markValetEZEmp",{user_id:popupDialog.formData?.user_id,...data}).then(response=>{
			setPopupDialog({ open: false,formData:{} })
			setSnackBar({
                open: true,
                message: response?.data?.msg,
                type: "success",
            })
		}).catch(err=>{
			setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })
		})

	}
    return (
        <>
            <ContainerHeader title={`Onboarding Users List`} />
            { loading &&  <div className='w-100'><LinearProgres color="primary" /></div> }
            { config && values &&
              <Formik
                  onSubmit={filterCity}
                  onReset={resetCity}
                  initialValues={values}
                  enableReinitialize
                  validationSchema={validations}
              >
              <>
                <UserDetails
                    config={config}
                    user={user}
                />        
                {userList &&
                <div className="row">
                    <ActionsTable
                        tableHeading={''}
                        table={userList}
                        handleImageDialog={ShowImages}
						            actions={true}
                        verifyUser={confirmVerifyUser}
                        uploadSelfDoc={uploadSelfDoc}
                        valetEZEmpDetail={valetEZEmpDetail}
                        downloadUserDocuments={downloadUserDocuments}
					          />
                </div>
                }
                </>
            </Formik>        
            }
            <Dialog
              open={dialog.open}
              TransitionComponent={Transition}
              keepMounted
              fullWidth
              maxWidth='md'
              onClose={handleDialogClose}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              PaperProps={{
                style: {
                  width: '95vw',
                  maxWidth: '95vw',
                }
              }}
            >
              <DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
              <DialogContent>
                {dialog.content}
              </DialogContent>
              <DialogActions>
                <Button variant="outlined"  color="secondary" onClick={handleDialogClose}> Close</Button>
                {dialog.submitBtnLabel && 
                  <Button variant="outlined"  color="primary" onClick={() => { dialog.callback(dialog.userData)}} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>
                }						
              </DialogActions>
            </Dialog>
			{
			(Object.keys(popupDialog?.formData).length)>0 &&
				<DialogForm
				open={popupDialog.open}
				header="ValetEZ employee detail"
				fields={[
					{
						"value": popupDialog.formData?.emp_code,
						"title": "Employee Code",
						"key": "emp_code",
						"help": "",
						"type": "input",
						"size": "3",
						"hidden": false,
						"disabled": false
					},
					{
						"value": popupDialog.formData?.deployed_vl_id?_.find(valetLocations,{id:popupDialog.formData.deployed_vl_id}):{},
						"title": "Deployed Location",
						"key": "deployed_vl_id",
						"help": "",
						"type": "autocomplete",
						"size": "4",
						"hidden": false,
						"multiSelect": false,
						"disabled": false,
						"options": valetLocations
					},
          {
            "value": moment(popupDialog.formData?.vl_shift_start_time, "HH:mm:00").toDate() || null,
            "title": "Shift Start Time",
            "key": "vl_shift_start_time",
            "help": "",
            "type": "timePicker",
            "size": "3",
            "hidden": false,
            "disabled": false
          },
          {
            "value": moment(popupDialog.formData?.vl_shift_end_time, "HH:mm:00").toDate() || null,
            "title": "Shift End Time",
            "key": "vl_shift_end_time",
            "help": "",
            "type": "timePicker",
            "size": "3",
            "hidden": false,
            "disabled": false
          }
				]}
				validationSchema={fieldValidation}
				onClose={() => {
					setPopupDialog({ open: false,formData:{} })
				}}
				onSubmit={agreeClicked}
				handleChange={(formik) => {}}
			/>
			}
			
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        </>
    )
}

export default ListUsers;